export const settings=[
    {
    element: '#settings-welcome',
    popover: {
      title: 'Welcome to Settings',
      description: 'Here you can manage your personal profile, client details, and team members.',
      position: 'top',
    },
  },
 {
    element: '.client_profile',
    popover: {
      title: 'Client Profile',
      description: 'Manage your organization or client-specific information including company name and contact details.',
      position: 'left',
    },
  },
  {
    element: '.user_profile',
    popover: {
      title: 'User Profile',
      description: 'View and update your personal information such as name, email, and password.',
      position: 'right',
    },
  },

  {
    element: '.members',
    popover: {
      title: 'Team Members',
      description: 'Add or remove team members, assign roles, and manage access permissions.',
      position: 'top',
    },
  },
    {
    element: '.integrations',
    popover: {
      title: 'Integrations',
      description: 'The Integration section allows you to connect with multiple marketing platforms, enabling you to track the performance of both ads and organic posts.',
      position: 'top',
    },
  },
{
    element: '.programs',
    popover: {
      title: 'Go Back To Programs',
      description: 'Click on Programs from sidebar',
      position: 'top',
    },
  },
 

]
